// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"368":"7dc7c85e","379":"c580d8b1","488":"43f6e873","730":"b35ef69f","767":"7a46a0f8"}[chunkId] + ".chunk.js";
};